import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import ClientDashboard from "@/pages/ClientDashboard";
import WillForm from "@/pages/WillForm";
import LpaForm from "@/pages/LpaForm";
import LegacyTrustForm from "@/pages/LegacyTrustForm";
import Pay from "@/pages/Pay";
import AdminDashboard from "@/pages/AdminDashboard";
import { PrivacyNotice, TermsOfBusiness, GuideToService } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy-notice" element={<PrivacyNotice />} />
            <Route path="/terms-of-business" element={<TermsOfBusiness />} />
            <Route path="/guide-to-service" element={<GuideToService />} />
            <Route path="/dashboard" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
            <Route path="/form" element={<ProtectedRoute><WillForm /></ProtectedRoute>} />
            <Route path="/lpa" element={<ProtectedRoute><LpaForm /></ProtectedRoute>} />
            <Route path="/legacy-trust" element={<ProtectedRoute><LegacyTrustForm /></ProtectedRoute>} />
            <Route path="/pay" element={<ProtectedRoute><Pay /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
